import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { router } from './router';
import { applyTheme, readStoredTheme } from './lib/theme';
import { bootDemoMask } from './demo/demo-mask';
import './demo/demo-mask.css';
import './theme.css';

// Apply the stored theme before the first paint (no flash, no inline script —
// the CSP in nginx.conf forbids one).
applyTheme(readStoredTheme());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5_000,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);

// T.Z112 — the «ПДн» personal-data mask: resolve the stored/default state and,
// when it is on, mask the first paint and install the mutation observer. After
// the router mounts so the walk covers the first rendered page too.
bootDemoMask();
